export enum FIELDTYPE {
  STRING,
  NUMBER,
  INTEGER,
}

export interface IDropDownListEntry {
  key: string;
  value: string;
  isDisabled: boolean;
  isSelected: boolean;
}
export interface IChipEntry {
  key: string;
  value: string;
}
